export default function QuickDrawIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M4 50 H60" stroke="#3B434F" strokeWidth="3" strokeLinecap="round" />
      <path d="M8 22 h14 M11 22 l2 -6 h4 l2 6" stroke="#2F8BFF" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" fill="#2F8BFF" />
      <path d="M12 25 h6 l1 14 l-2 10 M13 39 l-2 10" stroke="#2F8BFF" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M18 29 h9" stroke="#2F8BFF" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M42 22 h14 M45 22 l2 -6 h4 l2 6" stroke="#FF8A1F" strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" fill="#FF8A1F" />
      <path d="M46 25 h6 l1 14 l-2 10 M47 39 l-2 10" stroke="#FF8A1F" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M32 18 l3 7 l7 1 l-5 5 l2 7 l-7 -4 l-7 4 l2 -7 l-5 -5 l7 -1 z" fill="#E7ECF3" />
    </svg>
  );
}
